import React from 'react';

import { Text } from '@change/ds-core-ui/next';

import { useTopImpactStorySummary } from './hooks/useTopImpactStorySummary';

export const TopImpactStorySummary: React.FC<{
	summary: string;
	dataTestId: string;
	isMobile?: boolean;
	isFading?: boolean;
}> = ({ summary, dataTestId, isMobile = false, isFading = false }) => {
	const {
		data: { textClasses, containerClasses },
	} = useTopImpactStorySummary(isMobile, isFading);

	return (
		<div className={containerClasses} aria-hidden tabIndex={-1}>
			<Text size="large" className={textClasses} data-testid={dataTestId}>
				{summary}
			</Text>
		</div>
	);
};
